import { Attachment } from 'types/Attachment';
import { PaginationParams, SortParams } from 'types/Pagination';

export enum OperationStatus {
  Eligible = 'Éligible',
  AConfirmer = 'Éligibilité à confirmer',
  NonConfirme = 'Eligibilité non-confirmée à ce stade',
  Recommandations = 'Recommandations',
  Annule = 'Annulé',
  DossierEnCoursDeValidation = 'Dossier en cours de validation',
  Incomplet = 'Incomplet',
  RemisAuControle = 'Remis au contrôle',
  PreValide = 'Pré validé',
  BonPourPrime = 'Bon pour prime',
  NonConforme = 'Non-conforme (Qualité)',
  ActionEnCours = 'Actions en cours',
  Litige = 'Litige',
  Refuse = 'Refusé',
}

export enum OperationSortFields {
  libelle = 'libelle',
  fost = 'fost',
  montantPrime = 'montantPrime',
  statut = 'statut',
}

export const OperationStatusKeys = Object.fromEntries(
  Object.entries(OperationStatus).map(([key, value]) => [
    value.toLowerCase(),
    key,
  ]),
);

export interface OperationHistoryItem {
  date: string;
  value: OperationStatus;
}

export interface Operation {
  id: string;
  libelle?: string;
  fost?: string;
  montantPrime?: number;
  statut?: OperationStatus;
}

export interface OperationFull extends Operation {
  criteresEligibilite?: string;
  mentionsFacture?: string;
  pointsVigilance?: string;
  reference: string;
  date: string;
  datePrevisionnelleDevis?: string;
  immatriculation: string;
  identification: string;
  modeleVehicule: string;
}

export interface OperationDetails {
  operation: OperationFull;
  history: OperationHistoryItem[];
  attachments: Attachment[];
}

export interface Operations {
  records: OperationFull[];
  totalSize: number;
}

export interface OperationsSearchParams
  extends PaginationParams,
    SortParams<OperationSortFields> {}

export enum SecteurOperations {
  INDUSTRIE = 'Industrie',
  RESEAUX = 'Réseaux',
  TERTIAIRE = 'Tertiaire',
  AGRICULTURE = 'Agriculture',
  RESIDENTIEL = 'Résidentiel',
}
